// extracted by mini-css-extract-plugin
module.exports = {"cart-wrapper":"Lecture_cart-wrapper__IwJaz","free-lectures-wrapper":"Lecture_free-lectures-wrapper__RU4EI","hover-scale":"Lecture_hover-scale__i1oHO"};